import { render, staticRenderFns } from "./orderCard.vue?vue&type=template&id=53870a5d&scoped=true"
import script from "./orderCard.vue?vue&type=script&lang=js"
export * from "./orderCard.vue?vue&type=script&lang=js"
import style0 from "./orderCard.vue?vue&type=style&index=0&id=53870a5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53870a5d",
  null
  
)

export default component.exports